export default {"src":"/_next/static/media/0x0000000000085d4780b73119b644ae5ecd22b376.c044dbfa.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};